module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/workpath0/deck.mdx",
    "dirname": "/vercel/workpath0"
  }
}];